<template>
  <div>
    <h1>{{ $t("components.orderDetailsForOrderItem.header") }} {{ data.orderItem.id }}</h1>
    <p style="font-size: larger">
      {{ $t("components.orderDetailsForOrderItem.forOrderNumber") }} {{ data.id }}
      <slot />
      {{ $t("components.orderDetailsForOrderItem.created") }}: {{ data.created_at }} {{ $t("components.orderDetailsForOrderItem.createdBy") }}
      <span class="font-weight-bold">{{ data.created_by_name }}</span> email:
      <a :href="'mailto:' + data.created_by_email">{{ data.created_by_email }}</a>
      {{ $t("global.phone") }}: <b>{{ data.created_by_phone }}</b
      >.
    </p>
    <h2>{{ $t("components.orderDetailsForOrderItem.ordering") }}:</h2>

    <v-row no-gutters>
      <v-col class="py-1 px-2" md="4" cols="12">
        <v-text-field filled :label="$t('components.orderDetailsForOrderItem.companyName')" readonly v-model="data.contractor_name" />
        <v-text-field filled :label="$t('global.tin')" readonly v-model="data.contractor_tin" />
      </v-col>
      <v-col class="px-2" md="4" cols="12">
        <v-textarea :value="address" filled class="input-capitalize" height="145px" :label="$t('global.address')" no-resize readonly />
      </v-col>
      <v-col class="px-2" md="4" cols="12">
        <v-textarea filled height="145px" :label="$t('global.comment')" no-resize readonly v-model="data.service_order_comment" outlined />
      </v-col>
      <v-col class="px-2" md="4" cols="12">
        <v-text-field
          readonly
          :value="data.order_group_id"
          filled
          :label="$t('components.orderDetailsForOrderItem.idOrderGroup')"
          append-outer-icon="fa-copy"
          @click:append-outer="$copyText(data.order_group_id)"
        />
      </v-col>
      <v-col class="px-2" md="4" cols="12" v-if="!!data.project_name && data.project_name.length > 0">
        <v-text-field
          readonly
          :value="data.project_name"
          filled
          :label="$t('components.orderDetailsForOrderItem.projectAttribute')"
          append-outer-icon="fa-copy"
          @click:append-outer="$copyText(data.project_name)"
        />
      </v-col>
      <v-col class="px-2" md="4" cols="12" v-if="!!data.order_number && data.order_number.length > 0">
        <v-text-field
          readonly
          :value="data.order_number"
          filled
          :label="$t('components.orderDetailsForOrderItem.orderNumberAttribute')"
          append-outer-icon="fa-copy"
          @click:append-outer="$copyText(data.order_number)"
        />
      </v-col>
      <v-col class="px-2" md="4" cols="12" v-if="!!data.external_customer_name && data.external_customer_name.length > 0">
        <v-text-field
          readonly
          :value="data.external_customer_name"
          filled
          :label="$t('components.orderDetailsForOrderItem.clientAttribute')"
          append-outer-icon="fa-copy"
          @click:append-outer="$copyText(data.external_customer_name)"
        />
      </v-col>
    </v-row>

    <p style="font-size: larger">
      <span v-if="data.phone_numbers != null && data.phone_numbers.length > 3" style="text-transform: capitalize">
        {{ $t("global.phone") }}: {{ data.phone_numbers }}<br
      /></span>
      <span v-if="data.contractor_mail_addresses != null && data.contractor_mail_addresses.length > 3">
        {{ $t("components.orderDetailsForOrderItem.companyEmail") }}:
        <a :href="'mailto:' + data.contractor_mail_addresses">{{ data.contractor_mail_addresses }}</a
        ><br
      /></span>
    </p>
  </div>
</template>

<script>
export default {
  name: "OrderDetailsForOrderItem",
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  computed: {
    address() {
      let address = "";
      if (this.data.contractor_street_and_number != null) {
        address += this.data.contractor_street_and_number.toLowerCase() + "\r\n";
      }
      if (this.data.contractor_postal_code != null && this.data.contractor_city != null) {
        address += this.data.contractor_postal_code.toLowerCase() + " " + this.data.contractor_city.toLowerCase() + "\r\n";
      }
      if (this.data.contractor_country != null) {
        address += this.data.contractor_country.toLowerCase();
      }
      return address;
    }
  }
};
</script>

<style scoped></style>
